import './Footer.css';

export default function Footer() {
    return (
        <footer className='pieDePagina'>
            <p>
                Gracias por visitar mi web. ❤
            </p>
        </footer>
    );
}